module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "enFooter"
    }
  }, [_vm._m(0), _vm._v(" "), _c('language-switch', {
    staticClass: "inverse"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-info"
  }, [_c('div', {
    staticClass: "footer-nav"
  }, [_c('div', {
    staticClass: "brand-name"
  }, [_c('a', {
    attrs: {
      "href": "./"
    }
  }, [_c('img', {
    attrs: {
      "src": "assets/images/logo_gray.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "footer-navbar"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "./products.html"
    }
  }, [_vm._v("PRODUCTS")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "./start.html"
    }
  }, [_vm._v("HOW TO START")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "./about.html"
    }
  }, [_vm._v("ABOUT US")])])])])]), _vm._v(" "), _c('p', [_vm._v("© 2017, Everonet, a subsidiary company of CardInfoLink. All rights reserved.")]), _vm._v(" "), _c('p', [_vm._v("沪 ICP 备 11004387 号")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1a894401!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EnFooter.vue
// module id = 33
// module chunks = 1 2 3 4 5 6